import React from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import LocationsSettings from '../../components/LocationsSettings';

const VendorLocations = () => {
  return (
    <DashboardLayout>
      <LocationsSettings />
    </DashboardLayout>
  );
};

export default VendorLocations;
